import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const paper = {
  filler: css`
    padding: ${spacing(2)};
    border-start-start-radius: 0;
    border-start-end-radius: 0;
    margin-block-end: ${spacing(0.5)};
  `,
  widget: css`
    padding: ${spacing(2)};
  `,
}

export const skeleton = {
  filler: css`
    block-size: ${spacing(12)};
  `,
  header: css`
    block-size: ${spacing(5)};
  `,
  option: css`
    block-size: ${spacing(5)};
    inline-size: ${spacing(66)};
  `,
  button: css`
    block-size: ${spacing(5)};
    inline-size: ${spacing(12)};
    flex-shrink: 0;
  `,
}

export const paperWrapper = css`
  padding: ${spacing(0.5)};
`

export const wrapper = {
  content: css`
    padding-block-start: ${spacing(2)};
    padding-inline-start: ${spacing(5)};
  `,
  label: css`
    gap: ${spacing(1)};
  `,
  options: css`
    gap: ${spacing(1)};
  `,
  payment: css`
    gap: ${spacing(1)};
  `,
}

export const inputs = css`
  padding-block-start: ${spacing(2)};
  gap: ${spacing(2)};
`
